import { useState } from "react";
import AreaChips from "./AreaChips";
import AreaPanel from "./AreaPanel";
import BodyStage from "@/components/body3d/BodyStage";

export default function BodyAreaExplorer({ showFigure = true, chipPrefix = "body-chip" }) {
  const [slug, setSlug] = useState(null);
  const [open, setOpen] = useState(false);
  const select = (s) => {
    setSlug(s);
    setOpen(true);
  };
  const active = open ? slug : null;

  return (
    <div className={`grid items-center gap-10 ${showFigure ? "lg:grid-cols-[1fr_1.1fr] lg:gap-16" : ""}`}>
      {showFigure && (
        <div className="lg:order-2">
          <BodyStage active={active} onSelect={select} />
        </div>
      )}
      <div className="lg:order-1">
        <AreaChips active={active} onSelect={select} idPrefix={chipPrefix} />
      </div>
      <AreaPanel slug={slug} open={open} onOpenChange={setOpen} onSelect={setSlug} />
    </div>
  );
}
